import { gql } from '@apollo/client'

export const SEARCH_CHANNELS = gql`
  query SearchChannels($term: String!, $limit: Int, $offset: Int) {
    searchChannels(term: $term, limit: $limit, offset: $offset) {
      channels {
        id
        name
        description
        viewerIsOwner
        viewerIsFollowing
      }
      totalCount
      offset
      limit
    }
  }
`
